export default "__VITE_ASSET__18accaa1__"